const { SIMPLE } = require('../utils/redux-helpers');

module.exports = {
    OFFLINE: SIMPLE
};
